import React from 'react';
import { ButtonWithAnchor } from '../../hero-section/sticky-button';
import { ButtonVariants } from '../../../../Atoms/Button';
import { HeadingProps } from '../types';

const HeroHeading: React.FC<HeadingProps> = ({ subheading }) => {
  return (
    <>
      {/* Headings */}
      <div className="font-semibold text-s-56 md:text-s-32 leading-[110%] hidden xl:block md:block text-brand-1000 animate-[slideInNoFade_0.8s_ease-out_forwards]">
        ClearTax ITR Filing
        <br />
      </div>
      <div className="font-semibold leading-[110%] text-s-32 hidden sm:block lg:block text-brand-1000 sm:text-center animate-[slideInNoFade_0.8s_ease-out_forwards] md:leading-[120%] lg:text-s-48">
        ClearTax <br />
        ITR Filing
      </div>

      {/* Default Content */}
      <div className="pt-3 pb-6 text-gray-500 text-s-24 leading-relaxed font-medium md:text-base lg:pb-4 md:py-4 sm:pt-2 sm:pb-4 sm:text-base opacity-0 translate-y-12 animate-[slideIn_0.8s_ease-out_forwards] animate-delay-300">
        {subheading.text}
      </div>
      <div className="w-52">
        <ButtonWithAnchor
          className="text-base font-bold px-0 py-4 h-14 md:h-10 sm:h-10 opacity-0 translate-y-12 animate-[slideIn_0.8s_ease-out_forwards] animate-delay-600"
          buttonVariant={ButtonVariants.bluefilled}
          buttonLink={subheading.button.url}
          buttonText={subheading.button.text}
          trackLabel="hero_cta"
        />
      </div>
    </>
  );
};

export default HeroHeading;
